import React from 'react';
import styled from 'styled-components';
import { Select } from 'antd';

import { colors } from 'helpers/ColorHelper';
import { media } from 'helpers/MediaHelper';
import { getTranslatedString } from 'helpers/i18n';

const StyledContainer = styled.div`
  position: relative;
  display: flex;
  ${media.mobile`
    width: 100%;
  `};
`;

const StyledSelect = styled(Select)`
  width: 250px;
  .ant-select-selection {
    border-radius: 4px 0px 0px 4px;
  }

  .ant-select-selection__rendered .ant-row {
    display: flex;
    align-items: center;
  }
`;

const StyledButton = styled.button`
  color: ${props => (props.disabled ? colors.BATTLESHIP_GREY : '#fff')};
  background-color: ${props => (props.disabled ? 'var(--pale-grey)' : props.accentColor)};
  font-size: 12px;
  font-weight: bold;
  border: none;
  border-radius: 0px 4px 4px 0px !important;
  padding: 1px 24px 0;
  text-align: center;
  min-width: 110px;
  display: inline-block;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
`;

const SelectWithButton = ({
  accentColor = colors.ULTRAMARINE_BLUE,
  placeholder = getTranslatedString('landlordPortal.selectWithButton.all'),
  buttonCta = getTranslatedString('landlordPortal.selectWithButton.apply'),
  value,
  handleChange,
  bgColor,
  options,
  ...props
}) => {
  const [showButton, setShowButton] = React.useState(false);
  const [newValue, setNewValue] = React.useState(value);

  const onButtonClick = () => {
    handleChange(newValue);
  };

  const handleSelectChange = e => {
    setShowButton(!!e);
    setNewValue(e);
  };

  return (
    <StyledContainer bgColor={bgColor}>
      <StyledSelect
        placeholder={placeholder}
        value={newValue}
        {...props}
        onChange={handleSelectChange}
      >
        {options.map(option => (
          <Select.Option value={option.value} key={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </StyledSelect>
      <StyledButton disabled={!showButton} accentColor={accentColor} onClick={onButtonClick}>
        {buttonCta}
      </StyledButton>
    </StyledContainer>
  );
};

export default SelectWithButton;
